module.exports = __webpack_public_path__ + "img/tz.88c89454.svg";